import React, { Component } from 'react';
import { TransLink } from '../Common/Translations';

export default class PromotionDynamicBreadCrumb extends Component {
  filterEmptyRoutes() {
    const filteredRoutes = this.props.routes && this.props.routes.filter((obj) => {
      if (obj.label && obj.label !== 'undefined') {
        return obj;
      }
    });
    return filteredRoutes;
  }

  renderBreadCrumbs(paths) {
    let breadcrumbs = '';

    if (paths) {
      paths.push({
        label: this.props.name,
        path: this.props.path,
      });
      breadcrumbs = paths.map((route, index) => {
        const isLastBreadcrumb = index === paths.length - 1;
        const { label } = route;
        const routePath = index === 1 ? '/promotions' : route.path;

        if (label) {
          const breadcrumb = <li key={label} className={`breadcrumb-item ${isLastBreadcrumb ? 'breadcrumb-item-last' : ''}`}>
                              {
                                routePath === '/'
                                  ? <a href={routePath}>{label}</a>
                                  : <TransLink url={routePath}>{label}</TransLink>
                              }
                            </li>;

          return breadcrumb;
        }
      });
    }
    return breadcrumbs;
  }

  generateBreadCrumbs() {
    return this.renderBreadCrumbs(this.filterEmptyRoutes());
  }

  render() {
    return (
      <div className="container px-0">
        <ol className="breadcrumb mb-0 white">
          {this.generateBreadCrumbs()}
        </ol>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Promotion/PromotionDynamicBreadCrumb.js